
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ArrowRight } from 'lucide-react';

/**
 * HeroContent component
 * Main content for the hero section
 */
const HeroContent = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="container mx-auto px-4 relative z-20">
      <div className="max-w-4xl mx-auto text-center">
        <div className="space-y-6">
          <div className="inline-block py-1 px-3 text-sm font-medium bg-blue-900/40 text-blue-300 rounded-full backdrop-blur-sm border border-blue-800/50 mb-3">
            AI-Powered Market Research
          </div>
          
          {/* Hero heading with new font */}
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-blue-300 tracking-tight leading-tight">
            Market Intelligence
            <br />
            Reimagined
          </h1>
          
          {/* Hero subheading */}
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            AnalystX is your AI-powered market research assistant that delivers professional-quality insights in minutes, not days.
          </p>
          
          {/* CTA buttons */}
          <div className="flex justify-center pt-8">
            {isAuthenticated ? (
              <Link
                to="/chat"
                className="bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-xl text-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 hover:gap-3"
              >
                Go to App
                <ArrowRight className="h-5 w-5" />
              </Link>
            ) : (
              <Link
                to="/auth"
                className="bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-xl text-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 hover:gap-3"
              >
                Generate Your Free Report
                <ArrowRight className="h-5 w-5" />
              </Link>
            )}
          </div>
          
          {/* Trust indicators */}
          <div className="pt-8 text-gray-400">
            <p className="text-sm mb-3">Trusted by professionals</p>
            <div className="flex flex-wrap justify-center gap-8 opacity-80">
              <span className="text-lg font-semibold">Fortune 500</span>
              <span className="text-lg font-semibold">Tech Startups</span>
              <span className="text-lg font-semibold">Consulting Firms</span>
              <span className="text-lg font-semibold">Investment Banks</span>
              <span className="text-lg font-semibold">Healthcare</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroContent;
